import { Flex, Typography } from '@iheartjane/reefer';
import { useParams } from 'react-router';

import {
  OrderCompleteCheckIcon,
  OrderCompleteContainer,
} from '@jane/kiosk/components';

export const OrderCompleteMobile = () => {
  const { reservationId } = useParams<{ reservationId: string }>();

  return (
    <OrderCompleteContainer
      alignItems="center"
      flexDirection="column"
      justifyContent="flex-end"
      width="100%"
      height="100%"
    >
      <Flex width="32%" mb={24}>
        <OrderCompleteCheckIcon width="100%" height="100%" color="text-info" />
      </Flex>

      {reservationId && (
        <Typography color="text-info" mb={16} variant="h3-regular" as="h1">
          Order #{reservationId}
        </Typography>
      )}

      <Typography
        color="text-info"
        textAlign="center"
        variant="h2-semibold"
        as="h2"
      >
        All set! Grab your order at the counter.
      </Typography>
    </OrderCompleteContainer>
  );
};
